export const getDrawerVisibilitySelector = drawerType => state =>
    state.smallDrawer[drawerType].isVisible || false;
